<app-touareg-control-state-layout
  [countdownMessage]="countdownMessage"
  [showCountdown]="true"
></app-touareg-control-state-layout>
